module.exports = __webpack_public_path__ + "img/sure.7ac84345.png";